module.exports = __webpack_public_path__ + "static/media/AvenirNext-DemiBoldItalic.0232d7b4.woff";